import React, { useContext, useState } from 'react';
import { FormTextInput } from '../../../Components/FormTextInput';
import NewButton from '../../../NewComponents/NewButton';

import { ReactComponent as Close } from "../../../assets/icons/x.svg";
import { ReactComponent as PERSONAL } from "../../../assets/icons/personal.svg";
import { ReactComponent as ADMIN } from "../../../assets/icons/admin.svg";
import { useEnterKey } from '../../../Hooks/useEnterKey';
import { DataContext } from '../../../Context/DataContext';
import { NotificationContext } from '../../../Context/NotificationContext';
import axios from 'axios';
import { getFullHttpUrl } from '../../../firebase.config';
import { ReactComponent as Copy } from "../../../assets/icons/copy.svg";

const AddMemberPopUp = ({setShowAddMember, showAddMember, copyLink}) => {

    const [newUserFirstName, setNewUserFirstName] = useState("");
    const [newUserLastName, setNewUserLastName] = useState("");
    const [newUserEmail, setNewUserEmail] = useState("");
    const { teamData, userData } = useContext(DataContext);

  const { showNotification } = useContext(NotificationContext);

    const [createBtn, setCreateBtn] = useState("Send Invitation");

    const [selectedMemberRole, setSelectedMemberRole] = useState("member");

    const handleSendInvitation = async() => {
      if(!teamData){
        return showNotification("Error", "There was an error. Please, try again or refresh the page.", "error");
      }
        setCreateBtn("Sending...")
        try{
          console.log(teamData)
        await axios({
            method: "post",
            url: getFullHttpUrl("team-inviteMember"),
            data: {
                name: newUserFirstName + " " + newUserLastName,
                firstName: newUserFirstName,
                lastName: newUserLastName,
                email: newUserEmail.toLowerCase(),
                teamData: teamData,
                teamRole: selectedMemberRole,
                userInvited: userData.id,
              },
          })
            .then(async (res) => {

            if (res.data === "user-already-joined") {
                setCreateBtn("Send Invitation");
                setShowAddMember(false);
                return showNotification(
                "Error",
                "User already joined the team.",
                "error"
            );
            }
            if (res.data === "team-exists") {
                return showNotification(
                "Error",
                "User is already a member of a team. Please, remove the user from that team and try again.",
                "error"
            );
            } 

            showNotification(
                "Success",
                "User is invited to the team and invitation email sent to user email.",
                "success"
              );
            setNewUserEmail("");
            setNewUserFirstName("");
            setNewUserLastName("");

            }).catch(e => {
                // console.log(e);
                showNotification('Error', "There was an error. Please, try again or refresh the page.", 'error');
              }
              );
        }catch (e) {
            console.log(e);
            showNotification('Error', "There was an error. Please, try again or refresh the page.", 'error');
          }
          finally{
            setCreateBtn("Send Invitation");
            setShowAddMember(false);
          }
    }
        
    

    const triggerCreateUser = () => {
      if (showAddMember && newUserEmail !== "" && newUserFirstName !== "" && newUserFirstName !== "" && emailRegex.test(newUserEmail.toLowerCase())) {
          handleSendInvitation();
        }
      };
    
  useEnterKey(() => triggerCreateUser());

  const emailRegex = new RegExp("^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$");


    return (
      <div className="newPopUpModalWrap">
          <div className="newPopUpModalContainer" style={{gap: "1rem"}}>
            <h2 className="newPopUpModalTitle">Add Member</h2>
            <p className="teamPopUpModalText">Invite your team members to collaborate with you</p>
            <div className="teamMemberPopUpInputsWrap">
              <div className="quoteDetailsInputsContainer">
                <FormTextInput placeholder={"First Name"} value={newUserFirstName} onChange={setNewUserFirstName}/>
                <FormTextInput placeholder={"Last Name"} value={newUserLastName} onChange={setNewUserLastName}/>
              </div>
              <FormTextInput incorrect={ newUserEmail && !emailRegex.test(newUserEmail.toLowerCase())} placeholder={"Email"} value={newUserEmail} onChange={setNewUserEmail}/>
            </div>
            <div className="teamMemberPopUpRoleWrap">
              <h5 className="teamMemberPopUpRoleHeading">Member Role</h5>

              <div className="teamMemberPopUpRoleTab"  onClick={() => setSelectedMemberRole("member")} style={{borderColor: selectedMemberRole === "member" ? "#12abbf" : "#eff0f2"}}>
                <div className="teamMemberPopUpTabRow">
                  <PERSONAL/>
                  <h5 className="teamMemberPopUpRoleHeading">Member</h5>
                </div>
                <p className="teamMemberPopUpRoleText">Can place/manage orders, invite users, and make payments</p>
              </div>
              <div className="teamMemberPopUpRoleTab" onClick={() => setSelectedMemberRole("admin")} style={{borderColor: selectedMemberRole === "admin" ? "#12abbf" : "#eff0f2"}}>
              <div className="teamMemberPopUpTabRow">
                  <ADMIN/>
                  <h5 className="teamMemberPopUpRoleHeading">Admin</h5>
                </div>
                <p className="teamMemberPopUpRoleText">Everything a Member can do, plus remove users, update payment methods, and change the payment approach</p>
              </div>

            </div>
            
            <div className="newPopUpModalTextWrap">
                <NewButton disabled={createBtn === "Sending..." ||newUserFirstName === "" || newUserLastName === "" || newUserEmail === "" || !emailRegex.test(newUserEmail.toLowerCase())} text={createBtn} width="100%" onClick={() => handleSendInvitation()}/>
                {copyLink && <NewButton text={"Copy link"} width="100%" onClick={copyLink} back icon={true} customIcon={<Copy width={20} height={20}/>} whiteBtn/>}
                <NewButton text={"Cancel"} width="100%" onClick={() => {setShowAddMember(false)}} back icon={false} whiteBtn/>
            </div>
            <Close className="newPopUpModalCloseIcon" onClick={() => {setShowAddMember(false)}}/>
          </div>
      </div>
    );
  }


export default AddMemberPopUp;
